export default function useCaptcha() {
  async function getToken(action) {
    return new Promise((resolve, reject) => {
      if (typeof grecaptcha === "undefined") {
        reject(new Error("reCAPTCHA not loaded"))
        return
      }
      grecaptcha.ready(async () => {
        try {
          const token = await grecaptcha.execute(
            process.env.GATSBY_GOOGLE_RECAPTCHA_KEY,
            { action }
          )
          resolve(token)
        } catch (err) {
          reject(err)
        }
      })
    })
  }

  return { getToken }
}
